<template>
  <DefaultSection class="is-medium">
    <Container>
      <h2 class="is-title is-size-large has-text-weight-bold has-text-centered">
        {{ title }}
      </h2>

      <div class="columns is-multiline">
        <div
          v-for="step in steps"
          :key="step?.id"
          class="column is-one-quarter-desktop is-half is-flex"
        >
          <div class="step-box">
            <MediaSvgIcon
              v-if="step?.svgIcon"
              v-bind="step?.svgIcon"
              class="svg-image"
            />
            <p
              class="is-size-normal has-text-weight-medium"
              v-html="step?.text"
            />
          </div>
        </div>
      </div>
      <div
        class="status-feedback is-hidden-mobile is-hidden-tablet-only has-text-centered"
      >
        <img src="~/assets/img/status_feedback.png" alt="Status Feedback" />
      </div>
    </Container>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphStepsFragment } from '#graphql-operations'

defineProps<ParagraphStepsFragment>()
defineBlokkli({
  bundle: 'steps',
  propsFieldMapping: {
    title: null,
    steps: { type: 'field', name: 'field_steps' },
  },
})
</script>

<style scoped lang="scss">
h2.is-title {
  margin-bottom: toRem(80);
}

.step-box {
  display: flex;

  @include tablet {
    flex-direction: column;
  }

  .svg-image {
    margin-bottom: 1rem;
    margin-right: 2rem;
    color: $orange;
    height: 35px;
    width: 35px;
    @include tablet {
      height: 57px;
      width: 57px;
    }
  }
  border-radius: 10px;
  background-color: $pale-gray-blue;
  padding: 2rem 2rem;
  box-shadow: 0 12px 32px -8px rgba(26, 26, 26, 0.24);

  p {
    white-space: inherit;
    @include tablet {
      white-space: pre-line;
    }
  }
}

.status-feedback {
  img {
    max-width: 600px;
  }

  @include widescreen {
    img {
      max-width: 864px;
    }
  }
}

.columns > div:last-child {
  .step-box {
    background-color: $bright-gray-blue;
    color: $white;

    .svg-image {
      color: white;
    }
  }
}
</style>
